import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { AlertTriangle, CheckCircle, TrendingUp, Camera, MapPin } from 'lucide-react';
import { priceMonitoring, outlets } from '../../data/mockData';
export function PriceMonitoring() {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const compliantCount = priceMonitoring.filter(p => p.status === 'Compliant').length;
  const violationCount = priceMonitoring.filter(p => p.status === 'Violation').length;
  const avgPrice = Math.round(priceMonitoring.reduce((sum, p) => sum + p.price, 0) / priceMonitoring.length);
  const handleRowClick = (item: any) => {
    setSelectedItem(item);
    setShowDetailModal(true);
  };
  return <div className="space-y-6" data-id="element-905">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-906">
        <div data-id="element-907">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-908">
            Monitoring Harga SPHP
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-909">
            Pantauan kepatuhan HET di tingkat pengecer
          </p>
        </div>
        <Button onClick={() => setShowReportModal(true)} data-id="element-910">
          Input Laporan Lapangan
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-911">
        <Card className="border-l-4 border-l-green-500" data-id="element-912">
          <div className="flex items-center gap-4" data-id="element-913">
            <div className="p-3 bg-green-100 text-green-600 rounded-lg flex-shrink-0" data-id="element-914">
              <CheckCircle size={24} data-id="element-915" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-916">
              <p className="text-sm text-gray-500 mb-1" data-id="element-917">Outlet Patuh</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-918">
                {compliantCount}
              </p>
              <p className="text-xs text-green-600 mt-1" data-id="element-919">
                {Math.round(compliantCount / priceMonitoring.length * 100)}%
                dari total
              </p>
            </div>
          </div>
        </Card>
        <Card className="border-l-4 border-l-red-500" data-id="element-920">
          <div className="flex items-center gap-4" data-id="element-921">
            <div className="p-3 bg-red-100 text-red-600 rounded-lg flex-shrink-0" data-id="element-922">
              <AlertTriangle size={24} data-id="element-923" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-924">
              <p className="text-sm text-gray-500 mb-1" data-id="element-925">Pelanggaran HET</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-926">
                {violationCount}
              </p>
              <p className="text-xs text-red-600 mt-1" data-id="element-927">Perlu tindak lanjut</p>
            </div>
          </div>
        </Card>
        <Card className="border-l-4 border-l-bulog-blue" data-id="element-928">
          <div className="flex items-center gap-4" data-id="element-929">
            <div className="p-3 bg-blue-100 text-bulog-blue rounded-lg flex-shrink-0" data-id="element-930">
              <TrendingUp size={24} data-id="element-931" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-932">
              <p className="text-sm text-gray-500 mb-1" data-id="element-933">Rata-rata Harga</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-934">
                Rp {avgPrice.toLocaleString()}
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-935">Per kg</p>
            </div>
          </div>
        </Card>
      </div>

      <Card title="Laporan Monitoring Terbaru" data-id="element-936">
        <Table columns={[{
        header: 'Tanggal',
        accessor: 'date',
        className: 'hidden sm:table-cell'
      }, {
        header: 'Outlet',
        accessor: (item: any) => <div className="min-w-0" data-id="element-938">
                  <div className="font-semibold text-gray-900 truncate" data-id="element-939">
                    {item.outlet}
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5" data-id="element-940">
                    {item.item}
                  </div>
                </div>
      }, {
        header: 'Harga Jual',
        accessor: (item: any) => <span className="font-semibold text-gray-900" data-id="element-941">
                  Rp {item.price.toLocaleString()}
                </span>
      }, {
        header: 'HET',
        accessor: (item: any) => <span className="text-sm text-gray-600" data-id="element-942">
                  Rp {item.het.toLocaleString()}
                </span>,
        className: 'hidden md:table-cell'
      }, {
        header: 'Selisih',
        accessor: (item: any) => <span className={`font-bold ${item.diff > 0 ? 'text-red-600' : 'text-green-600'}`} data-id="element-943">
                  {item.diff > 0 ? `+Rp ${item.diff.toLocaleString()}` : 'Sesuai'}
                </span>
      }, {
        header: 'Status',
        accessor: (item: any) => <Badge variant={item.status === 'Violation' ? 'danger' : 'success'} data-id="element-944">
                  {item.status === 'Violation' ? 'Melanggar' : 'Patuh'}
                </Badge>
      }]} data={priceMonitoring} keyExtractor={i => i.id} onRowClick={handleRowClick} data-id="element-937" />
      </Card>

      {/* Detail Modal */}
      <Modal isOpen={showDetailModal} onClose={() => setShowDetailModal(false)} title="Detail Monitoring Harga" size="lg" data-id="element-945">
        {selectedItem && <div className="space-y-6" data-id="element-946">
            <div className="grid grid-cols-2 gap-4" data-id="element-947">
              <div data-id="element-948">
                <p className="text-sm text-gray-500 mb-1" data-id="element-949">Outlet</p>
                <p className="font-semibold text-gray-900" data-id="element-950">
                  {selectedItem.outlet}
                </p>
              </div>
              <div data-id="element-951">
                <p className="text-sm text-gray-500 mb-1" data-id="element-952">Tanggal Monitoring</p>
                <p className="font-semibold text-gray-900" data-id="element-953">
                  {selectedItem.date}
                </p>
              </div>
              <div data-id="element-954">
                <p className="text-sm text-gray-500 mb-1" data-id="element-955">Harga Jual</p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-956">
                  Rp {selectedItem.price.toLocaleString()}
                </p>
              </div>
              <div data-id="element-957">
                <p className="text-sm text-gray-500 mb-1" data-id="element-958">HET Resmi</p>
                <p className="text-2xl font-bold text-bulog-blue" data-id="element-959">
                  Rp {selectedItem.het.toLocaleString()}
                </p>
              </div>
            </div>

            <div className="p-4 bg-gray-50 rounded-lg" data-id="element-960">
              <div className="flex items-center gap-2 mb-2" data-id="element-961">
                <Camera size={18} className="text-gray-500" data-id="element-962" />
                <p className="font-semibold text-gray-900" data-id="element-963">Bukti Foto</p>
              </div>
              <div className="grid grid-cols-2 gap-3" data-id="element-964">
                <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-965">
                  <Camera className="text-gray-400" size={32} data-id="element-966" />
                </div>
                <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-967">
                  <Camera className="text-gray-400" size={32} data-id="element-968" />
                </div>
              </div>
            </div>

            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-969">
              <div className="flex items-start gap-2" data-id="element-970">
                <MapPin size={18} className="text-bulog-blue mt-0.5 flex-shrink-0" data-id="element-971" />
                <div data-id="element-972">
                  <p className="font-semibold text-bulog-blue mb-1" data-id="element-973">
                    Lokasi GPS
                  </p>
                  <p className="text-sm text-gray-700" data-id="element-974">-6.2088, 106.8456</p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-975">
                    Verifikasi: Sesuai dengan alamat outlet
                  </p>
                </div>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Report Modal */}
      <Modal isOpen={showReportModal} onClose={() => setShowReportModal(false)} title="Input Laporan Monitoring Harga" size="lg" footer={<>
            <Button variant="outline" onClick={() => setShowReportModal(false)} data-id="element-977">
              Batal
            </Button>
            <Button onClick={() => {
        setShowReportModal(false);
        alert('Laporan berhasil disimpan!');
      }} data-id="element-978">
              Simpan Laporan
            </Button>
          </>} data-id="element-976">
        <div className="space-y-4" data-id="element-979">
          <Select label="Pilih Outlet" options={[{
          value: '',
          label: 'Pilih outlet...'
        }, ...outlets.map(o => ({
          value: o.id,
          label: `${o.name} - ${o.region}`
        }))]} data-id="element-980" />
          <Input type="date" label="Tanggal Monitoring" data-id="element-981" />
          <Input label="Harga Jual (Rp/kg)" placeholder="10900" type="number" data-id="element-982" />
          <Input label="Stok Display (kg)" placeholder="100" type="number" data-id="element-983" />
          <div className="p-4 border-2 border-dashed border-gray-300 rounded-lg text-center" data-id="element-984">
            <Camera className="mx-auto text-gray-400 mb-2" size={32} data-id="element-985" />
            <p className="text-sm font-medium text-gray-900" data-id="element-986">
              Upload Foto Harga & Stok
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-987">JPG, PNG (Max 5MB)</p>
            <Button size="sm" variant="outline" className="mt-3" data-id="element-988">
              Pilih Foto
            </Button>
          </div>
          <Input label="Catatan" placeholder="Kondisi outlet, ketersediaan stok, dll..." data-id="element-989" />
        </div>
      </Modal>
    </div>;
}